module.exports = __webpack_public_path__ + "media/gyik_k.62809b5b.mp3";